import { Row, Spin } from "antd";
import { FC } from "react";

export const FormSpinner: FC = () => (
  <Row justify="center" align="middle" style={{ padding: 32 }}>
    <Spin />
  </Row>
);
